import React, { useEffect } from "react";
import styled from "styled-components";
import { getHeaderTheme } from "../../../config/headerTheme";
import { shootQuizConfetti } from "../utils/shootQuizConfetti";

const QuizResult = ({ quiz, correctCount, onRestart }) => {
  useEffect(() => {
    shootQuizConfetti();
  }, []);

  if (!quiz) return null;

  const earnedPoints = correctCount * 2;

  return (
    <ResultCard>
      <ResultHero>
        <BadgeRing>🎉</BadgeRing>
        <h2>¡Trivia completada!</h2>
        <p>{quiz.title}</p>
      </ResultHero>

      <ScoreGrid>
        <ScoreTile>
          <span>Correctas</span>
          <strong>{correctCount}</strong>
        </ScoreTile>
        <ScoreTile>
          <span>Puntos</span>
          <strong>{earnedPoints}</strong>
        </ScoreTile>
      </ScoreGrid>

      <ResultNote>
        Gracias por jugar. Puedes volver al listado de trivias cuando quieras.
      </ResultNote>

      <ResultActions>
        <PrimaryButton type="button" onClick={onRestart}>
          Ver trivias
        </PrimaryButton>
      </ResultActions>
    </ResultCard>
  );
};

export default QuizResult;

const ResultCard = styled.div`
  margin: 40px auto 0;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 24px;
  padding: 36px;
  text-align: center;
  border: 1px solid #e2e8f0;
  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.08);
`;

const ResultHero = styled.div`
  h2 {
    margin: 12px 0 6px;
    font-size: 28px;
    color: #0f172a;
  }

  p {
    margin: 0;
    color: #64748b;
    font-size: 16px;
  }
`;

const BadgeRing = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 24px;
  background: #0f172a;
  color: #fff;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.2);
`;

const ScoreGrid = styled.div`
  margin: 26px 0 18px;
  display: grid;
  gap: 16px;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const ScoreTile = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 18px;
  border: 1px solid #e2e8f0;
  display: grid;
  gap: 6px;

  span {
    font-size: 14px;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  strong {
    font-size: 30px;
    color: #0f172a;
  }
`;

const ResultNote = styled.p`
  margin: 0;
  color: #64748b;
  font-size: 15px;
`;

const ResultActions = styled.div`
  margin-top: 22px;
  display: flex;
  justify-content: center;
`;

const theme = getHeaderTheme();

const PrimaryButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 12px 18px;
  background: ${theme.primary};
  color: ${theme.text};
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
`;
